export const affiliateIds = ["KCoPkmzGxIh0jIMf12aVtyRP9Xc2"];

const DEFAULT_REFERRAL_PARAMS = {
  utm_source: "rinderr.com",
  utm_medium: "referral",
  utm_campaign: "ring_listing",
};

const CAPUCINNE_PARAMS = {
  linkId: "Rinder_influencer_influencer",
  affluencerId: "Rinder",
};

const appendParams = (url, params) => {
  try {
    const parsed = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
      if (!parsed.searchParams.has(key)) {
        parsed.searchParams.set(key, value);
      }
    });
    return parsed.toString();
  } catch (error) {
    console.warn("Unable to append referral params to url:", url, error);
    return url;
  }
};

export const getUrlForAffiliate = (url, userId) => {
  if (!url) return url;

  if (affiliateIds.includes(userId)) {
    switch (userId) {
      case "KCoPkmzGxIh0jIMf12aVtyRP9Xc2":
        return appendParams(url, CAPUCINNE_PARAMS);
      default:
        return appendParams(url, DEFAULT_REFERRAL_PARAMS);
    }
  }

  return appendParams(url, DEFAULT_REFERRAL_PARAMS);
};
